import React from "react";
import { CrudPage } from "@/components/CrudPage";
import { StatusBadge } from "@/components/StatusBadge";
import { REPAIR_STATUS, URGENCY } from "@/lib/constants";

const STATUS_OPTS = Object.entries(REPAIR_STATUS).map(([value, v]) => ({ value, label: v.label }));
const URG_OPTS = Object.entries(URGENCY).map(([value, v]) => ({ value, label: v.label }));

const columns = [
  { key: "content", label: "修繕内容", render: (r) => <span className="font-medium">{r.content}</span> },
  { key: "property_id", label: "物件", render: (r, h) => h.nameOf("properties", r.property_id) },
  { key: "urgency", label: "緊急度", render: (r) => <StatusBadge value={r.urgency} map={URGENCY} /> },
  { key: "vendor_id", label: "業者", render: (r, h) => (r.vendor_id ? h.nameOf("vendors", r.vendor_id) : "-") },
  { key: "estimate_amount", label: "見積", render: (r, h) => h.yen(r.estimate_amount) },
  { key: "payment_amount", label: "支払額", render: (r, h) => h.yen(r.payment_amount) },
  { key: "status", label: "状態", render: (r) => <StatusBadge value={r.status} map={REPAIR_STATUS} /> },
];

const fields = [
  { name: "content", label: "修繕内容", required: true, colSpan: 2 },
  { name: "property_id", label: "物件", type: "select", lookup: "properties", required: true },
  { name: "room_id", label: "部屋", type: "select", lookup: "rooms" },
  { name: "tenant_id", label: "入居者", type: "select", lookup: "tenants" },
  { name: "urgency", label: "緊急度", type: "select", options: URG_OPTS, default: "medium" },
  { name: "vendor_id", label: "業者", type: "select", lookup: "vendors" },
  { name: "status", label: "状態", type: "select", options: STATUS_OPTS, default: "received" },
  { name: "estimate_amount", label: "見積金額", type: "currency" },
  { name: "order_amount", label: "発注金額", type: "currency" },
  { name: "payment_amount", label: "支払額", type: "currency" },
  { name: "scheduled_date", label: "工事予定日", type: "date" },
  { name: "completed_date", label: "完了日", type: "date" },
  { name: "photo_url", label: "写真", type: "file" },
  { name: "completed_photo_url", label: "完了写真", type: "file" },
  { name: "note", label: "備考", type: "textarea" },
];

export default function Repairs() {
  return (
    <CrudPage
      title="修繕管理"
      subtitle="受付 → 見積 → 承認 → 発注 → 工事 → 完了 → 支払"
      endpoint="/repairs"
      resource="repairs"
      columns={columns}
      fields={fields}
      testid="repairs"
      addLabel="修繕を登録"
      searchKeys={["content"]}
    />
  );
}
